export default {
  dateTimeFormat: () => {
    return 'l LT'
  },

  dateFormat: () => {
    return 'l'
  },
}
